import Amplify, { Auth } from "aws-amplify";
import RemoteServices from "@/services/RemoteServices";
// import store from "@/store/store";
import AuthDto from "@/domain/user/AuthDto";
import i18n from "@/i18n";

// TODO check here
Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',

    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_AWS_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    // identityPoolRegion: 'XX-XXXX-X',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_AWS_COGNITO_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    /* cookieStorage: {
      // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      domain: '.yourdomain.com',
      // OPTIONAL - Cookie path
      path: '/',
      // OPTIONAL - Cookie expiration in days
      expires: 365,
      // OPTIONAL - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
      sameSite: "lax",
      // OPTIONAL - Cookie secure flag
      // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      secure: true
    }, */

    // OPTIONAL - customized storage object
    // storage: Storage,

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_PASSWORD_AUTH',
  }
});
// You can get the current config object

// const currentConfig = Auth.configure()

export default class AuthService {
  cognitoUser = null;

  async doAwsCognitoSignIn(
    username: string
  ){
    this.cognitoUser = null;
    return await Auth.signIn(username).then(async user => {
      if(user.challengeName === "CUSTOM_CHALLENGE") {
       this.cognitoUser = user;
        return true;
      }
      else if (user.challengeName != null && user.challengeName !== "") {
        console.log(user.challengeName);
        throw new Error(i18n.tc("user.auth.error"));
      }
    });
  }

  async doAwsCognitoCompleteChallenge(password: string){
    let result;
    if(this.cognitoUser == null)
      throw new Error("No email provided, try again.")
    console.log("SAPO")
    try {
      result = await Auth.sendCustomChallengeAnswer(this.cognitoUser, password)
          }catch (error){
      throw new Error("Too many failed attempts, try again.")
    }
    if(result!=null && result.challengeName)
      throw new Error("Verification Code is Incorrect")
    }


  async doLogout() {
    await Auth.signOut();
  }

  getIdToken(): Promise<string> {
    return new Promise<string>(resolve =>
      Auth.currentSession().then(session => {
        resolve(session.getIdToken().getJwtToken());
      })
    );
  }

  async isLoggedIn(): Promise<boolean> {
    return Auth.currentAuthenticatedUser()
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  async fetchUserInfo(): Promise<AuthDto> {
    if (await this.isLoggedIn()) {
      try {
        return await RemoteServices.getUserInformation();
      } catch (error) {
        throw new Error("Error getting User Information from backend");
      }
    } else {
      throw new Error("Not authenticated");
    }
  }
}
